import { render, staticRenderFns } from "./ScaffoldForm.vue?vue&type=template&id=340f17be&scoped=true"
import script from "./ScaffoldForm.vue?vue&type=script&lang=js"
export * from "./ScaffoldForm.vue?vue&type=script&lang=js"
import style0 from "./ScaffoldForm.vue?vue&type=style&index=0&id=340f17be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f17be",
  null
  
)

export default component.exports